// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { BulkJobParameters } from './bulkJobParameters';
import type { AutogradeJobParams } from './autogradeJobParams';
import type { TestJobParams } from './testJobParams';
import type { ResourceProcessJobParams } from './resourceProcessJobParams';

export type RunJobRequestParams = BulkJobParameters | AutogradeJobParams | TestJobParams | ResourceProcessJobParams;
